import { BaseManualDeactivationField } from 'features/geoEvents/components/BaseManualDeactivationField';
import { useFormContext } from 'react-hook-form';

type FloodingFormValues = {
  isParent: boolean;
};

type FloodingManualDeactivationFieldProps = {
  hasEvacZones: boolean;
};

export const FloodingManualDeactivationField = (
  props: FloodingManualDeactivationFieldProps,
): JSX.Element => {
  const { hasEvacZones } = props;

  const { watch } = useFormContext<FloodingFormValues>();

  const isParent = watch('isParent');

  const isDeactivationBlocked = Boolean(isParent);

  return (
    <BaseManualDeactivationField
      hasEvacZones={hasEvacZones}
      isExternallyBlocked={isDeactivationBlocked}
    />
  );
};
